<template>
  <!--編輯-->
  <v-dialog v-model="isVisible"
            no-click-animation
            max-width="50%">
    <v-card>
      <v-card-text>
        <v-layout xs12 v-if="category === 0 || category === 3">
          <v-flex>
            <v-btn class="primary" dark text  @click="printCreditView(2)">CA申請書編輯</v-btn>
          </v-flex>
        </v-layout>
        <br/>
        <!-- <v-layout xs12 v-if="category === 0 || category === 3">
          <v-flex>
            <v-btn class="primary" dark text  @click="printCreditView(3)">轉和潤申請書</v-btn>
          </v-flex>
        </v-layout>
        <br/> -->
        <v-layout xs12 v-if="(category === 0 || category === 3)">
          <v-flex>
            <v-btn class="primary" dark text  @click="printCreditView(10)">CA申請書-列印</v-btn>
          </v-flex>
        </v-layout>
        <br/>
        <v-layout xs12 v-if="(category === 0 || category === 3) && isAdmin">
          <v-flex>
            <v-btn class="primary" dark text  @click="printCreditView(11)">CA申請書-套印</v-btn>
          </v-flex>
        </v-layout>
        <!-- <br/>
        <v-layout xs12 v-if="(category === 0 || category === 3) && isAdmin">
          <v-flex>
            <v-btn class="primary" dark text  @click="printCreditView(1)">和潤進件(雲鼎)-列印</v-btn>
          </v-flex>
        </v-layout>
        <br/>
        <v-layout xs12 v-if="(category === 0 || category === 3) && isAdmin">
          <v-flex>
            <v-btn class="primary" dark text  @click="printCreditView(2)">和潤進件(和灣)-列印</v-btn>
          </v-flex>
        </v-layout> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="primary" dark text @click="confirmEvent">確定</v-btn>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CaDialog',
  props: {
    visible: Boolean,
    category: Number,
  },
  data() {
    return {
      loading: false,
      valid: true,
      dialog: false,
      isVisible:false,
    };
  },
  watch:{
    visible(value){
        this.isVisible = value;
    },
    isVisible(value){
      if(!value)
      {
        this.$emit('closeEvent');
      }
    }
  },
  computed:{
    ...mapGetters(['getUserInfo',]),
    isAdmin() {
      return this.getUserInfo.authority === 'admin';
    },
  },
  methods: {
    printCreditView(eventKey){
      this.$emit('showEvent', eventKey);
    },
    confirmEvent(){
      this.$emit('confirmEvent', true);
    }
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CaDialog.vue